import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import StatsCards from '../components/dashboard/StatsCards';
import ActivitiesTable from '../components/dashboard/ActivitiesTable';
import ActionCards from '../components/dashboard/ActionCards';
import StaffSensorOrders from '../components/dashboard/StaffSensorOrders';
import UserHeader from '../components/UserHeader';

const Dashboard: React.FC = () => {
  const { isStaff } = useAuth();

  const getFullMonth = () => {
    const months = [
      'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
      'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];
    const now = new Date();
    return `${months[now.getMonth()]} ${now.getFullYear()}`;
  };

  return (
    <div className="container" style={{ padding: '40px' }}>
      <UserHeader title={getFullMonth()} />
      <StatsCards />
      <ActivitiesTable />
      <ActionCards />
      {isStaff && <StaffSensorOrders />}
    </div>
  );
};

export default Dashboard;
